import { render, staticRenderFns } from "./HomeSpareSkins.vue?vue&type=template&id=5905427b&scoped=true&"
import script from "./HomeSpareSkins.vue?vue&type=script&lang=ts&"
export * from "./HomeSpareSkins.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSpareSkins.vue?vue&type=style&index=0&id=5905427b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5905427b",
  null
  
)

export default component.exports